import {
    GET_WEATHER_CAMS,
    GET_WEATHER_CAM_DETAIL,
    GET_WEATHER_CAMS_WITH_GEOJSON } from '../actions/weatherCamActions';
import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    listIsRefreshing: false,
    detailIsRefreshing: false
};

const geometryType = 'Point';
const featureType = 'Feature';
const geoJsonType = 'FeatureCollection';



function transformCameraToGeoJSON ( camera, camNumber = 0 ) {
    const geoJSONResult = {
        geometry: {},
        properties: {},
        type: ''
    };

    const { Id, Lat, Lng } = camera;

    const coordinates = [
        Lng,
        Lat
    ];

    const geometry = {
        type: geometryType,
        coordinates: coordinates
    };

    const properties = {
        id: Id,
        camNumber: `${camNumber + 1}`,
        latitude: Lat,
        longitude: Lng
    };

    geoJSONResult.geometry = geometry;
    geoJSONResult.properties = properties;
    geoJSONResult.type = featureType;


    return geoJSONResult;
}

const transformCamerasDataToGeoJSON = ( cameras ) => {
    return cameras.map( (camera, index) => transformCameraToGeoJSON(camera, index));
};

export function weatherCam(state = initialState, action)
{
    switch (action.type)
    {
        case LOCATION_CHANGED:
        {
            return initialState;
        }
        case GET_WEATHER_CAMS.pending:
        {
            return {
                ...state
                , list: undefined
                , listIsRefreshing: true
            };
        }

        case GET_WEATHER_CAMS.fulfilled:
        {

            return {
                ...state
                , list: action.payload
                , lastError: {}
                , listIsRefreshing: false
            };
        }

        case GET_WEATHER_CAMS.rejected:
        {
            return {
                ...state
                , list: undefined
                , lastError: action.payload
                , listIsRefreshing: false
            };
        }

        case GET_WEATHER_CAMS_WITH_GEOJSON.pending:
        {
            return {
                ...state
                , list: undefined
                , camListGeoJSON: undefined
                , listIsRefreshing: true
            };
        }

        case GET_WEATHER_CAMS_WITH_GEOJSON.fulfilled:
        {
            const geojson = {
                features: transformCamerasDataToGeoJSON(action.payload),
                type: geoJsonType
            };

            return {
                ...state
                , list: action.payload
                , camListGeoJSON: geojson
                , lastError: {}
                , listIsRefreshing: false
            };
        }

        case GET_WEATHER_CAMS_WITH_GEOJSON.rejected:
        {
            return {
                ...state
                , list: undefined
                , camListGeoJSON: undefined
                , lastError: action.payload
                , listIsRefreshing: false
            };
        }
        case GET_WEATHER_CAM_DETAIL.pending:
        {
            return {
                ...state
                , detail: undefined
                , camDetailGeoJSON: undefined
                , detailIsRefreshing: true
            };
        }

        case GET_WEATHER_CAM_DETAIL.fulfilled:
        {
            const detailGeoJson = {
                features: transformCameraToGeoJSON(action.payload),
                type: geoJsonType
            };
            return {
                ...state
                , detail: action.payload
                , camDetailGeoJSON: detailGeoJson
                , lastError: {}
                , detailIsRefreshing: false
            };
        }
        case GET_WEATHER_CAM_DETAIL.rejected:
        {
            return {
                ...state
                , detail: undefined
                , camDetailGeoJSON: undefined
                , lastError: action.payload
                , detailIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
